import { useMutation, useQueryClient } from '@tanstack/react-query';

import { paymentRepo } from '@ctct/domain-layer';

import { useMutationMemoized } from '../helpers/useMutationMemoized';
import { QueryKeys } from '../queries/constants';

export const useUpdateCurrency = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: paymentRepo.updateCurrency,
    onSuccess: () => {
      // when currency has been changed - we need to refetch BILLING_ACCOUNT query and EXTENDED_BILLING_ACCOUNT query
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BILLING_ACCOUNT] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.EXTENDED_BILLING_ACCOUNT] });
    },
  });

  return useMutationMemoized(mutation);
};

export type UpdateCurrencyMutation = ReturnType<typeof useUpdateCurrency>;
